import { FreeTrial as GuestPassRecipient } from '@mc/api'
import { EventTypes, trackPage } from '@mc/track-event'

export const checkoutCtaTrackProps = {
  location: 'hero',
}

export const trackExclusiveGuestPassPageViewed = (
  guestPass: GuestPassRecipient,
) => {
  trackPage(EventTypes.RECIPIENT_GUEST_PASS, {
    platform: 'next',
    ...(guestPass?.advocate &&
      !guestPass.partnership && {
        advocate_id: guestPass.advocate.id,
        advocate_email: guestPass.advocate.email,
      }),
  })
}
